<template>
  <div class="animation-upload">
    <div class="animation-boot">
      <div class="animation-boot-btn">
        <span>{{ title }}</span>
        <el-input v-model="fileName"></el-input>
        <el-upload
          action="/api/1/attachments/upload"
          :show-file-list="false"
          :on-success="uploadSuccess"
          :on-progress="uploadProgress"
        >
          <el-button type="primary">{{ $t("commonMsg.upload") }}</el-button>
        </el-upload>
        <el-button class="review" type="primary" plain @click="review">{{
          $t("commonMsg.preview")
        }}</el-button>
      </div>
      <el-progress
        v-if="uploadState"
        type="line"
        :percentage="percent"
      ></el-progress>
      <div class="animation-boot-explain">
        <i class="el-icon-warning"></i>
        <span>{{ explain }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    explain: {
      type: String,
      default: "无说明"
    }
  },
  data() {
    return {
      fileName: "",
      fileUrl: "",
      fileID: "",
      percent: 0,
      uploadState: false
    };
  },
  methods: {
    uploadSuccess(data) {
      this.elMsg(`${this.title}${$t("alertMsg.uploadSuccess")}`, "success");
      this.fileName = data.data.filename;
      this.fileUrl = data.data.url;
      this.fileID = data.data.id;
      this.filterType();
    },

    filterType() {
      let obj = {};
      switch (this.title) {
        case this.$t("org.powerOn"):
          obj = { boot_anim_id: this.fileID };
          break;
        case this.$t("org.standby"):
          obj = { standby_id: this.fileID };
          break;
        case this.$t("org.powerOff"):
          obj = { poweroff_id: this.fileID };
          break;
        default:
          break;
      }

      this.$emit("uploadSuccess", obj);
      this.uploadState = false;
    },

    uploadProgress(data) {
      this.uploadState = true;
      this.percent = parseInt(data.percent);
    },

    review() {
      window.open(this.fileUrl, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.animation-upload {
  padding: 15px 0;
  .animation-boot {
    .animation-boot-btn {
      display: flex;
      align-items: center;
      .el-input {
        // width:240px;
        flex: 1;
        margin: 0 20px;
      }
      .review {
        margin-left: 20px;
      }
    }
    .animation-boot-explain {
      margin-top: 10px;
      > span {
        margin: 0 10px;
        font-size: 14px;
      }
    }
  }
}
</style>
